export class Record {
    toString() {
        return JSON.stringify(this);
    }
}
export class Stats {
    constructor(name, debugging) {
        this.debugging = false;
        this.records = new Map();
        this.name = name;
        if (debugging)
            this.debugging = true;
    }
    logDebug(message, ...args) {
        if (this.debugging) {
            console.debug(message, ...args);
        }
    }
    getOrCreateRecord(key) {
        let record = this.records.get(key);
        if (record === undefined) {
            record = new Record();
            this.records.set(key, record);
        }
        return record;
    }
    getRecord(key) {
        return this.records.get(key);
    }
    start(args) {
        let record = this.getOrCreateRecord(args.key);
        record.start = Date.now();
        let msg = '';
        if (args.message !== undefined) {
            msg = ', message=' + JSON.stringify(args.message);
        }
        this.logDebug('stats::%s.%s started: record=%s%s', this.name, args.key, record, msg);
    }
    end(args) {
        let record = this.getOrCreateRecord(args.key);
        record.end = Date.now();
        if (typeof record.start === 'number') {
            record.duration = record.end - record.start;
        }
        else {
            console.warn('stats::%s.%s not started yet', this.name, args.key);
        }
        let msg = '';
        if (args.message !== undefined) {
            msg = ', message=' + JSON.stringify(args.message);
        }
        this.logDebug('stats::%s.%s ended: record=%s%s', this.name, args.key, record, msg);
        if (!args.keep)
            this.records.delete(args.key);
    }
}
